import { render, staticRenderFns } from "./CategoryDiscountTitle.vue?vue&type=template&id=140d3462&"
import script from "./CategoryDiscountTitle.vue?vue&type=script&lang=js&"
export * from "./CategoryDiscountTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/DIA-3dprima_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('140d3462')) {
      api.createRecord('140d3462', component.options)
    } else {
      api.reload('140d3462', component.options)
    }
    module.hot.accept("./CategoryDiscountTitle.vue?vue&type=template&id=140d3462&", function () {
      api.rerender('140d3462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/CategoryDiscountTitle.vue"
export default component.exports